export const docCodeConstants = {
  TASK: { prefix: "TASK", suffix: "", pad: "0", padSize: 4 },
  ENQUIRY: { prefix: "ENQUIRY", suffix: "", pad: "0", padSize: 4 },
  PROJECT: { prefix: "PRJ", suffix: "", pad: "0", padSize: 4 },
  PRODUCT: { prefix: "PRD", suffix: "", pad: "0", padSize: 4 },
  CATALOGUE: { prefix: "PCD", suffix: "", pad: "0", padSize: 4 },
  PRODUCT_LOT: { prefix: "LOT", suffix: "", pad: "0", padSize: 4 },
  HANDOVER_CHECKLIST: { prefix: "PHO", suffix: "", pad: 0, padSize: 4 },
};

export const docNameFromDocType = {
  1: "TASK",
  2: "ENQUIRY",
  3: "PROJECT",
  4: "PRODUCT",
  5: "CATALOGUE",
  6: "PRODUCT_LOT",
};

export const taskDocId = {
  misc: 1,
  enquiry: 2,
  project: 3,
  product: 4,
  catalogue: 5,
  productLot: 6,
};
